/**
 * CommodityLogo — Professional 3D commodity icons with white backgrounds.
 * Maps commodity symbols to high-quality 3D rendered images.
 */

// New white-background 3D icons (Feb 2026)
const COMMODITY_GROUP_IMAGES = {
  "Crude Oil": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/0f93b436d258b3a8fba1eac8dd40cae05b038f0b370c198f787ca21643b58dfe.png',
  "Gold": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/2c7d92d541b75d6b414f783fe554bdb8b3007200eb6cb15dc840717648fb9158.png',
  "Natural Gas": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/1ef5dad56c20125ec6cfd8837654828771092a76a247d98771f292eff47ef5cb.png',
  "Silver": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/015434a9fb9490d8dda63d356ad06f753081b4b075d7c5e19dd5e6dd138cc8dd.png',
  "Zinc": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/5a142fb7ce385b01903e1b810cd05c2f6fee58f2b3ae09f2960ae39d0b06db35.png',
  "Copper": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/ec123b67c6fd5753f2427d7aee3c5325102f38709033640d50d63584cea68346.png',
  "Aluminium": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/e9354801a3492caf4001edd55453efe4075421835108fc75ccca5c7d820d51e2.png',
  "Electricity": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/8264861bf44f49fb224c1db86bbf4f9d50401e25a3f646d94e0820225f223d2f.png',
  "Nickel": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/a734a86e8e3011186a7dc6d8a1c62343403b2141e9e3c5b4913db36047f0cdec.png',
  "Lead": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/ffb3934d15196999e3e53b6a6b06a0adc0ac3aebad066996282c70fce22a3a76.png',
  "Cotton": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/7e1cd186163b498848fa33fd287eaf1445db4b867534d94243bcccbe30795161.png',
  "Cotton Oil": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/08e465bf0397a81c1aa489650c272a984cff4a489c496aecb1e6cc28be273115.png',
  "Mentha Oil": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/5f3db2284c6ce112a6d3e62e3e13c2fee5c76794d8aa86f3088b779e66cd2896.png',
  "Cardamom": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/caf67b0a023fcd44566da885db60af526cc1b844440de5db13ac9a9beee1e431.png',
  "Steel": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/a253b91918a2580c98980a5180b6e79067af2db947a1906026987ced4fddd749.png',
  "MCX Indices": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/655f4438162cf6fc07dc58ae3c984953bcc29d352f9fbf5a0c006734c8e1776b.png',
  "Kapas": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/7e1cd186163b498848fa33fd287eaf1445db4b867534d94243bcccbe30795161.png',
  "Castor Seed": 'https://static.prod-images.emergentagent.com/jobs/a06f92b7-8b04-4c84-b793-911d4918478a/images/caf67b0a023fcd44566da885db60af526cc1b844440de5db13ac9a9beee1e431.png',
};

// Map commodity symbols to their group names for icon lookup
const SYMBOL_TO_GROUP = {
  CRUDEOIL: "Crude Oil", CRUDEOILM: "Crude Oil",
  GOLD: "Gold", GOLDM: "Gold", GOLDGUINEA: "Gold", GOLDPETAL: "Gold", GOLDPETALDEL: "Gold", GOLDTEN: "Gold",
  NATURALGAS: "Natural Gas", NATGASMINI: "Natural Gas",
  SILVER: "Silver", SILVERM: "Silver", SILVERMIC: "Silver",
  ZINC: "Zinc", ZINCMINI: "Zinc",
  COPPER: "Copper", COPPERM: "Copper",
  ALUMINIUM: "Aluminium", ALUMINI: "Aluminium",
  NICKEL: "Nickel", NICKELM: "Nickel",
  LEAD: "Lead", LEADMINI: "Lead",
  COTTON: "Cotton", COTTONFINE: "Cotton",
  COTTONOIL: "Cotton Oil",
  MENTHAOIL: "Mentha Oil",
  KAPAS: "Kapas",
  CARDAMOM: "Cardamom", CASTORSEED: "Castor Seed",
  ELECDMBL: "Electricity",
  STEELREBAR: "Steel",
  MCXBULLDEX: "MCX Indices", MCXMETLDEX: "MCX Indices",
};

export function getGroupIcon(groupName) {
  return COMMODITY_GROUP_IMAGES[groupName] || null;
}

export default function CommodityLogo({ symbol, group, size = 40, className = '' }) {
  // Resolve image: prefer group name, fallback to symbol-to-group mapping
  const groupName = group || SYMBOL_TO_GROUP[symbol?.toUpperCase()];
  const imageUrl = groupName ? COMMODITY_GROUP_IMAGES[groupName] : null;

  if (!imageUrl) {
    const label = (symbol || '??').slice(0, 2).toUpperCase();
    return (
      <div
        className={`flex items-center justify-center rounded-full font-bold select-none shrink-0 bg-gray-100 text-gray-500 ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.35 }}
        data-testid={`commodity-logo-${symbol}`}
      >
        {label}
      </div>
    );
  }

  return (
    <div
      className={`rounded-full overflow-hidden shrink-0 bg-white ${className}`}
      style={{ width: size, height: size }}
      data-testid={`commodity-logo-${symbol || group}`}
    >
      <img
        src={imageUrl}
        alt={groupName || symbol}
        loading="lazy"
        className="w-full h-full object-cover"
        onError={(e) => {
          e.target.style.display = 'none';
          const parent = e.target.parentElement;
          parent.classList.add('flex', 'items-center', 'justify-center', 'bg-gray-100', 'text-gray-500', 'font-bold');
          parent.style.fontSize = `${size * 0.35}px`;
          parent.textContent = (symbol || group || '??').slice(0, 2).toUpperCase();
        }}
      />
    </div>
  );
}

export { COMMODITY_GROUP_IMAGES, SYMBOL_TO_GROUP };
